import React, { CSSProperties, useEffect, useState } from 'react'
import * as st from '~/assets/styl/WorkModal.module.styl'
import * as st2 from '~/assets/styl/CommonAreas.module.styl'
import cn from 'classnames'
import { Lightbox, Modal, Tabs } from '~/components'
import { Image } from '~/components/Lightbox'
import Slider, { ArrowType } from '@fil1pe/react-slider'
import getYoutubeId from 'get-youtube-id'
import { useLanguage } from '~/hooks'

export default function WorkModal({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  useEffect(() => {
    if (open && location.pathname !== MODAL_URL)
      history.pushState({}, '', MODAL_URL)
  }, [open])

  const [stages, setStages] = useState<Stage[]>([])
  const [progress, setProgress] = useState(0)
  const [stageImages, setStageImages] = useState<StageImage[]>([])
  const [stageVideos, setStageVideos] = useState<StageVideo[]>([])
  const [zoomIndex, setZoomIndex] = useState(0)
  const [zoomImages, setZoomImages] = useState<Image[] | null>(null)

  useEffect(() => {
    fetch('https://dimasconstrucoes.com.br/api/api/enterprises/d-vert')
      .then((data) => data.json())
      .then(
        ({
          result,
        }: {
          result: {
            stages: Stage[]
            total_progress: number
            imagesStages: StageImage[]
            videosStages: StageVideo[]
          }
        }) => result
      )
      .then(({ stages, total_progress, imagesStages, videosStages }) => {
        setStages(stages)
        setProgress(total_progress)
        setStageImages(imagesStages)
        setStageVideos(videosStages)
      })
      .catch((err) => console.error(err))
  }, [])

  const isMobile =
    typeof window !== 'undefined' &&
    window.matchMedia('(max-width: 767px)').matches
  const { t } = useLanguage()
  return (
    <>
      <Modal
        open={
          open &&
          Boolean(
            stageImages.length || stageVideos.length || stageVideos.length
          )
        }
        onClose={onClose}
        onBeforeClose={() => history.pushState({}, '', '/dvert-residence/')}
        className={st.modal}
        style={{ background: '#E3EBDB', animationDuration: 0.2 }}
      >
        {(closeProps) => (
          <>
            <button {...closeProps}></button>
            <h3>{t('WorkModal.title')}</h3>
            <Tabs
              items={[
                t('WorkModal.tabItems.1'),
                t('WorkModal.tabItems.2'),
                t('WorkModal.tabItems.3'),
              ]}
              className={st.tabs}
            >
              <ul className={st.stages}>
                {stages.map(({ id, stage: { name }, quantity }) => (
                  <Progress key={id} name={name} value={quantity} />
                ))}
                <Progress name="Andamento total" value={progress} />
              </ul>
              {Boolean(stageImages.length) && (
                <div>
                  <WorkSlider isMobile={isMobile}>
                    {stageImages.map(({ legend, miniature }, index) => (
                      <div
                        key={index}
                        className={st.slide}
                        onClick={() => {
                          setZoomIndex(index)
                          setZoomImages(
                            stageImages.map(({ url, legend }) => ({
                              url,
                              legend,
                            }))
                          )
                        }}
                      >
                        <img src={miniature} alt={legend} />
                        <span>{legend}</span>
                      </div>
                    ))}
                  </WorkSlider>
                </div>
              )}
              {Boolean(stageVideos.length) && (
                <div>
                  <WorkSlider isMobile={isMobile}>
                    {stageVideos.map(({ url, legend }, key) => {
                      const id = getYoutubeId(url)
                      return (
                        <a
                          href={`https://www.youtube.com/watch?v=${id}`}
                          target="_blank"
                          rel="noreferrer"
                          key={key}
                          className={st.slide}
                        >
                          <img
                            src={`https://img.youtube.com/vi/${id}/0.jpg`}
                            alt={legend}
                          />
                          <span>{legend}</span>
                        </a>
                      )
                    })}
                  </WorkSlider>
                </div>
              )}
            </Tabs>
          </>
        )}
      </Modal>

      <Lightbox
        index={zoomIndex}
        setIndex={setZoomIndex}
        images={zoomImages}
        setImages={setZoomImages}
      />
    </>
  )
}

function Progress({ name, value }: { name: string; value: number }) {
  return (
    <li style={{ '--progress': value + '%' } as CSSProperties}>
      <span>{name}</span>
      <div>{!value && 'Não iniciado'}</div>
      <span>{value}%</span>
    </li>
  )
}

function WorkSlider({
  children,
  isMobile,
}: {
  children: React.ReactNode
  isMobile: boolean
}) {
  return (
    <Slider
      slidesToShow={isMobile ? 1 : 3}
      renderArrow={({ className, ...props }, type) => (
        <button
          {...props}
          className={cn(className, st2.arrow, {
            [st2.next]: type === ArrowType.Next,
          })}
        ></button>
      )}
      pagination={1}
      className={cn(st.slider, st2.slider)}
    >
      {children}
    </Slider>
  )
}

const MODAL_URL = '/dvert-residence/acompanhe-a-obra/'

interface Stage {
  id: number
  stage: {
    id: number
    name: string
    slug: string
  }
  quantity: number
  position: number
}

interface StageImage {
  miniature: string
  legend: string
  url: string
}

interface StageVideo {
  url: string
  legend: string
}
